export const header = {
    fontSize: 35,
}

export const headerTwo = {
    fontSize: 30,
}
